import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Lambda from './gates/lambda/Lambda.js'
import Alpha from './gates/alpha/Alpha.js'
import Parabola from './gates/parabola/Parabola.js'

import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";
import Secret from "./gates/secret/Secret";

const router = createBrowserRouter([
    {
        path: "/",
        element: React.createElement(Lambda, null),
    },
    {
        path: "/alpha",
        element: React.createElement(Alpha, null),
    },
    {
        path: "/parabola",
        element: React.createElement(Parabola, null),
    },
    {
        path: "/seeeecret",
        element: React.createElement(Secret, null),
    },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);


